const modules = {

  /*
  ==========================================================
  TRANSPORTATION
  ==========================================================
  */

  transportation: {

    name:
      "Transporte",

    description:
      "Administre reservas, despacho, vehículos, conductores, rutas y las operaciones de transporte."

  },

  /*
  ==========================================================
  ADVENTURES
  ==========================================================
  */

  adventure: {

    name:
      "Aventuras",

    description:
      "Administre tours, guías, horarios, actividades y reservas de aventuras."

  },

  /*
  ==========================================================
  RENTALS
  ==========================================================
  */

  rentals: {

    name:
      "Alquileres",

    description:
      "Administre inventario, disponibilidad, reservas, devoluciones y alquileres de los clientes."

  },

  /*
  ==========================================================
  RESTAURANTS
  ==========================================================
  */

  restaurants: {

    name:
      "Restaurantes",

    description:
      "Administre mesas, reservaciones, menús, órdenes y las operaciones del restaurante."

  },

  /*
  ==========================================================
  CLINICS
  ==========================================================
  */

  clinics: {

    name:
      "Clínicas",

    description:
      "Administre citas, pacientes, personal médico y los servicios clínicos."

  },

  /*
  ==========================================================
  HOTELS
  ==========================================================
  */

  hotels: {

    name:
      "Hoteles",

    description:
      "Administre habitaciones, reservaciones, huéspedes, limpieza y las operaciones del hotel."

  }

};

export default modules;